interface NameParts {
  firstName?: string | null;
  lastName?: string | null;
}

export function getFullName(name: NameParts | null | undefined): string;
export function getFullName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string;
export function getFullName(
  firstNameOrName: NameParts | string | null | undefined,
  lastName?: string | null,
): string {
  if (typeof firstNameOrName === "object" && firstNameOrName !== null) {
    return getFullName(firstNameOrName.firstName, firstNameOrName.lastName);
  }
  return [firstNameOrName, lastName].filter(Boolean).join(" ");
}

export function formatPhone(phoneNumber: string): string | null {
  const cleaned = phoneNumber.replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    if (match[1]) {
      return `+1 (${match[2]}) ${match[3]}-${match[4]}`;
    }
    return `(${match[2]}) ${match[3]}-${match[4]}`;
  }
  return phoneNumber;
}
